import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ComponentRef, OnDestroy, ViewChild, ViewContainerRef, signal } from '@angular/core';
import { XMLElementBaseComponent } from '../base';
import { Paragraph } from '../volkswagen.types';
import { ChapterLinkComponent } from './chapter-link.component';
import { QVChapterComponent } from './qv-chapter.component';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-vw-paragraph',
  imports: [CommonModule, TranslocoPipe, ChapterLinkComponent, QVChapterComponent],
  standalone: true,
  template: `
    <div class="mb-4 mt-4">
      @if (data.text && data.typ === 'normal') {
        <p class="mb-2 text-gray-700">{{ data.text }}</p>
      }
      @if (data.text && data.typ === 'hervor') {
        <h4 class="mb-2 text-lg font-bold">{{ data.text }}</h4>
      }

      @for (link of links(); track $index + link.ziel) {
        @if (link.tag === 'qv-kap') {
          <app-vw-qv-chapter [data]="link"></app-vw-qv-chapter>
        } @else if (false && link.tag === 'qv-pos') {
          <!-- TODO: !!!!!!!!!!!!!!!!!!!! -->

          <a [href]="'#' + link.ziel" class="border border-red-500 text-blue-800 hover:underline">
            <i class="pi pi-arrow-right pr-2 !text-[10px]"></i>
            {{ 'documents.vw.seeHere' | transloco }} {{ link.ziel }}
          </a>
        }

        @if (link.tag === 'ext-rl') {
          <app-vw-chapter-link [data]="link"></app-vw-chapter-link>
        }
      }

      <ng-template #childrenContainer></ng-template>
    </div>

    <!-- <pre class="bg-violet-50 text-xs">{{ data | json }}</pre> -->
  `,
})
export class ParagraphComponent extends XMLElementBaseComponent<Paragraph> implements AfterViewInit, OnDestroy {
  @ViewChild('childrenContainer', { read: ViewContainerRef })
  childrenContainer!: ViewContainerRef;

  private childComponents: ComponentRef<XMLElementBaseComponent>[] = [];

  // private linkTags = ['qv-kap', 'qv-pos', 'ext-rl'];
  private linkTags = ['qv-pos', 'ext-rl'];
  links = signal<any[]>([]);

  ngAfterViewInit() {
    const links = this.data?.children?.filter((child) => this.linkTags.includes(child.tag)) || [];
    this.links.set(links);

    if (this.data?.children) {
      this.childRenderService.setProvider(this.provider);
      const furtherChildren = this.data?.children?.filter((child: any) => !['wz'].includes(child.tag)) || [];
      this.childComponents = this.childRenderService.renderChildren(furtherChildren, this.childrenContainer);
    }
  }

  ngOnDestroy() {
    this.childComponents.forEach((ref) => ref.destroy());
  }
}
